<template>
    <div class="row">
        <div class="col-12">
            <!--button v-if="$UserSession.hasPriv('ATTENDANCE_LOG_DOWNLOAD')"
                class="btn btn-outline-secondary ml-2 float-lg-right float-left" :title="$t('download')" @click="generateCSV()">
                <b-icon-download />
            </button-->
            <h1 class="mb-4">{{$t('attendance-report')}}</h1>
            <div v-if="student" class="d-flex align-items-start mb-2">
                <Avatar class="avatar flex-shrink-0 mr-4" 
                        :userId="student?.id" />
                <div>
                    <h2 class="mb-1">{{ student?.displayName }}</h2>
                    <p class="text-muted mb-0">
                        {{ $t('programme') }}: {{ $config.getProgrammeNameById(student?.programme) }}, {{ $t('year') }}: {{ student?.year }}, {{ $t('group') }} {{ $config.getGroupNameById(student?.group) }}
                    </p>
                </div>
            </div>
            <ActionModal
                v-if="loading || error?.error"
                :title="loading ? $t('loading') : (error?.error ? $t('error') : $t('no-data-found'))"
                :text="loading ? $t('loading') : (error?.error ? $t(error.errorMessage) : $t('no-data-found-text'))"
                :iconType="loading ? '' : (error?.error ? 'exclamation-triangle-fill' : 'exclamation-triangle-fill')"
                :iconVariant="error?.error ? 'danger' : 'danger'"
                iconSize="7.5"
                :modalStyle="{ width: '18rem', margin: '40px auto 0' }"
            />
            <Table
                v-else
                :loading="loading"
                :submitting="submitting"
                :cols="[
                    { key: 'ttevent_title', heading: $t('title'), size: 9},
                    { key: 'ttevent_date', heading: $t('date'), size: 1 },
                    { key: 'ttevent_time', heading: $t('time'), size: 1 },
                    { key: 'attended', heading: $t('attendance'), size: 1,
                        cb: (entry) => {
                            if(entry.attended == 1) return $t('attended');
                            if(entry.attended == 0) return entry.absencetype_title ? entry.absencetype_title : $t('absent');
                            return $t('unknown');
                        },
                        icon: (entry) => {
                            if(entry.attended == 1) return { icon: 'check-circle-fill', variant: 'success' };
                            if(entry.attended == 0) return { icon: 'x-circle-fill', variant: 'danger' };
                            return { icon: 'question-circle-fill', variant: 'secondary' };
                        }
                    }
                ]"
                :data="report"
                breakpoint="md"
                :filters="{
                    ...filters,
                    page: filters.page,
                    page_size: filters.page_size,
                    total_count: total_count
                }"
                :searchable="true"
                :scrollPaginate="true"
                @refresh="refresh"
                @toPage="toPage"
            >
                <!-- Table Header -->
                <template v-slot:header>
                   <div class="list-group-item">
                        <div class="d-flex flex-wrap align-items-end">
                            <div class="d-flex flex-column mr-2">
                                <DateInput 
                                    :label="$t('from')" 
                                    v-model="filters.datetime_from" 
                                    @input="value => refresh({ datetime_from: value })"
                                />
                            </div>
                            <div class="d-flex flex-column mr-2">
                                <DateInput 
                                    :disabled="!filters.datetime_from"
                                    :label="$t('to')" 
                                    v-model="filters.datetime_to" 
                                    @input="value => refresh({ datetime_to: value })" 
                                />
                            </div>
                            <div class="btn-group ml-2 mb-3">
                                <button class="btn btn-on-good"
                                    :class="{
                                        'btn-primary': filters.attended,
                                        'btn-outline-secondary': !filters.attended
                                    }" @click="{ filters.attended = !filters.attended; fetchReport();}"
                                    >
                                    {{ $t('attended') }}
                                </button>
                                <button class="btn btn-on-good"
                                    :class="{
                                        'btn-primary': filters.absent,
                                        'btn-outline-secondary': !filters.absent
                                    }" @click="{ filters.absent = !filters.absent; fetchReport();}"
                                    >
                                    {{ $t('absent') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:options>
                </template>
            </Table>
        </div>
    </div>
</template>

<script>
import Table from "src/components/Table/Table.vue";
import CSVGenerator from "src/modules/csvgenerator.js"
import DateInput from "src/components/Inputs/DateInput";
import Avatar from "src/components/Avatar.vue";
import ActionModal from "../../components/ActionModal.vue";

export default {
    components: {
        Table,
        DateInput,
        Avatar,
        ActionModal
    },
    data() {
        return {
            report: [],
            filters: {
                page: 1,
                page_size: 30,
                search: '',
                source: null,
                order: '',
                show_disabled_users: false,
                status: '',
                programme: '',
                year: '',
                attended: true,
                absent: true,
                student_id: this.$route.params["user_id"] ? this.$route.params["user_id"] : this.$UserSession.getValue("id"),
            },
            student: null,
            status: null,
            total_count: 0,
            roles: [],
            error: null,
            loading: true,
            submitting: false,
            editUserId: 0,
            csvCols : ['id', 'firstname', 'lastname', 'email', 'username', 'email', 'jobtitle']
        }
    },
    async mounted() {
        if(this.$UserSession.getValue("id") == this.$route.params["user_id"]){
            if(!this.$UserSession.hasPriv('ATTENDANCE_REPORT_VIEW') && !this.$UserSession.hasPriv('ATTENDANCE_OWN_REPORT_VIEW')){
                this.$router.push('/');
                return;
            }
        } else {
            if(!this.$UserSession.hasPriv('ATTENDANCE_REPORT_VIEW')){
                this.$router.push('/');
                return;
            }
        }
        if(this.$route.params["user_id"]){
            this.fetchStudent();
        }

        this.fetchReport().then(() => {
            this.loading = false
        });
    },
    methods: {
        fetchReport() {
            this.submitting = true;
			return this.$cfetch(`${this.$settings.APIBaseURL}/attendance/studentreport`, {
				data:  this.filters,
                method: 'POST'
			}).then((res) => {
                if (res.status !== "SUCCESS") {
                    this.error = res;
                    throw new Error(res);
				}

                // if(this.filters.page == 1) this.log = res.result
                // else this.log = [...this.log, ...res.result]

                this.report = res.results;

                this.filters.page = res.pagination.page
                this.filters.page_size = res.pagination.page_size
                this.filters.total = res.pagination.total

                this.report.forEach( event => {
                    event.ttevent_date = this.$datetime.getLocaleStringFromISODate(event.ttevent_datetimefrom.split(' ')[0]);
                    event.ttevent_time = `${this.$datetime.isoDateTimeToTime(event.ttevent_datetimefrom)} - ${this.$datetime.isoDateTimeToTime(event.ttevent_datetimeto)}`;

                    event.created = `${this.$datetime.getLocaleStringFromISODate(event.created)} ${this.$t('at')} ${this.$datetime.isoDateTimeToTime(event.created)}`;
                    if(event.teacher_id){ 
                        event.source_text = `${this.$t('manual-entry')} - ${event.teacher_name}`;
                        //event.source = 'manual-entry';
                    }
                    if(event.formresponse_id){ 
                        event.source_text = this.$t('form-submission');
                        //event.source = 'form';
                    }
                    if(event.ttcheckincode_code) {
                        event.source_text = `${this.$t('qr-code')} - ${event.ttcheckincode_code}`;
                        //event.source = 'qr-code';
                    }
                    
                });
                
			}).catch((err) => {
                this.$log.error.call(this, err)
                console.error(err); 
            }).finally(() => {
                this.submitting = false;
			});
		},
        fetchStudent(){
            return this.$users.getUserById.call(this, this.$route.params["user_id"]).then(user => {
                this.student = user
            }).catch((err) => {
                this.$log.error.call(this, err)
                console.error(err); 
            });
        },
        refresh(filters) {
            this.filters = { ...this.filters, ...filters, page: 1 }
            this.fetchReport()
        },
        toPage(pageNo) {
            console.log(pageNo);
            this.filters.page = pageNo
            this.fetchReport()
        },
        generateCSV() {

            let colNames = {};

            for (let col in this.csvCols){
                colNames[this.csvCols[col]] = this.$t(this.csvCols[col])
            }

            this.filters.fetch_all = true;


            this.listUsers().then(()=>{

                const csvHandler = new CSVGenerator(this.users, colNames, 'class_test');
                
                return csvHandler.getCSV().catch((err) => console.error(err));
            })

        },
    }
}
</script>
